import React from 'react'
import classnames from 'classnames'
import styles from './CarouselNavigator.module.scss'

const CarouselNavigator = ({ size, selected, handleClick = () => {} }) => (
  <div className={styles.root}>
    {[...Array(size).keys()].map(key => (
      <button
        type="button"
        onClick={() => handleClick(key)}
        className={styles.button}
        key={key}
      >
        <div
          className={classnames(
            styles.dot,
            key === selected ? styles.dotSelected : styles.dotUnselected
          )}
        />
      </button>
    ))}
  </div>
)

export default React.memo(CarouselNavigator)
